/**
 * Bookings realtime subscription hook
 * Handles Supabase realtime subscriptions for bookings table
 */

import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to manage realtime subscriptions for bookings
 * Automatically invalidates bookings queries when changes occur
 */
export const useBookingsRealtime = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Create unique channel ID to avoid conflicts
    const channelId = `bookings-changes-${Math.random().toString(36).substr(2, 9)}`;
    
    const channel = supabase
      .channel(channelId)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'bookings'
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ["bookings"] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
};
